import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function AdminDashboard() {
  const navigate = useNavigate();

  const cards = [
    {
      title: "PYQ",
      status: "LIVE",
      desc: "Previous Year Questions practice karo",
      action: () => navigate("/user/previous-year-papers"),
    },
    {
      title: "Test Series",
      status: "COMING",
      desc: "Full length mock tests (coming soon)",
    },
    {
      title: "Courses",
      status: "COMING",
      desc: "Complete video courses (coming soon)",
    },
    {
      title: "QBank",
      status: "COMING",
      desc: "Topic-wise practice questions (coming soon)",
    },
  ];

  const userGetMeResponse = useSelector(
    (state) => state.apiReducer.userGetMe?.response
  );
  const userData = userGetMeResponse?.data || {};

  const user = {
    name: userData?.name || "User",
    email: userData?.email || "user@example.com",
    plan: userData?.plan || "Free",
    duration: userData?.duration || "30 days",
    expiry: userData?.expiry,
    testsAttempted: userData?.testsAttempted || 0,
    accuracy: userData?.accuracy || 0,
    rank: userData?.rank || "-",
  };

  return (
    <div
      style={{
        padding: "20px",
        background: "#0f172a",
        minHeight: "100vh",
        color: "white",
        fontFamily: "sans-serif",
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ fontWeight: "bold" }}>Dashboard</h2>
        <p style={{ color: "#94a3b8" }}>
          Welcome back, {user.name} 👋
        </p>
      </div>

      {/* Profile + Stats */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        {/* Profile */}
        <div
          style={{
            flex: "1 1 300px",
            background: "#1e293b",
            padding: "20px",
            borderRadius: "16px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                background: "#6366f1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "20px",
                fontWeight: "bold",
                marginRight: "15px",
              }}
            >
              {user.name.charAt(0)}
            </div>

            <div>
              <h5 style={{ margin: 0 }}>{user.name}</h5>
              <p style={{ margin: 0, color: "#94a3b8" }}>
                {user.email}
              </p>
            </div>
          </div>

          <div style={{ marginTop: "20px" }}>
            <p>Plan: <strong>{user.plan}</strong></p>
            <p>Duration: <strong>{user.duration}</strong></p>
            <p>
              Expiry:{" "}
              <strong style={{ color: "#ef4444" }}>
                {user.expiry}
              </strong>
            </p>
          </div>
        </div>

        {/* Stats */}
        <div
          style={{
            flex: "1 1 300px",
            background: "#1e293b",
            padding: "20px",
            borderRadius: "16px",
          }}
        >
          <h4 style={{ marginBottom: "15px" }}>Performance</h4>

          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              textAlign: "center",
            }}
          >
            <div>
              <h3 style={{ color: "#3b82f6" }}>{user.testsAttempted}</h3>
              <small>Tests</small>
            </div>
            <div>
              <h3 style={{ color: "#22c55e" }}>{user.accuracy}%</h3>
              <small>Accuracy</small>
            </div>
            <div>
              <h3 style={{ color: "#f59e0b" }}>#{user.rank}</h3>
              <small>Rank</small>
            </div>
          </div>

          {/* Progress */}
          <div style={{ marginTop: "20px" }}>
            <small>Overall Progress</small>
            <div
              style={{
                height: "8px",
                background: "#334155",
                borderRadius: "10px",
                marginTop: "5px",
              }}
            >
              <div
                style={{
                  width: `${user.accuracy}%`,
                  height: "100%",
                  background: "#22c55e",
                  borderRadius: "10px",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Cards Section */}
      <div style={{ marginTop: "40px" }}>
        <h2 style={{ marginBottom: "20px" }}>
          🚀 Your Learning Dashboard
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "20px",
          }}
        >
          {cards.map((item, index) => {
            const isLive = item.status === "LIVE";

            return (
              <div
                key={index}
                onClick={item.action}
                style={{
                  background: "#1e293b",
                  padding: "20px",
                  borderRadius: "16px",
                  cursor: isLive ? "pointer" : "not-allowed",
                  position: "relative",
                  border: isLive
                    ? "2px solid #22c55e"
                    : "1px solid #334155",
                  boxShadow: isLive
                    ? "0 0 15px rgba(34,197,94,0.3)"
                    : "none",
                  transition: "0.3s",
                }}
              >
                {/* Badge */}
                <span
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    fontSize: "11px",
                    padding: "4px 10px",
                    borderRadius: "20px",
                    background: isLive ? "#22c55e" : "#f59e0b",
                    color: isLive ? "white" : "black",
                  }}
                >
                  {isLive ? "LIVE" : "COMING"}
                </span>

                <h3>{item.title}</h3>
                <p style={{ color: "#94a3b8", fontSize: "14px" }}>
                  {item.desc}
                </p>

                <button
                  disabled={!isLive}
                  style={{
                    marginTop: "15px",
                    padding: "8px 15px",
                    border: "none",
                    borderRadius: "8px",
                    background: isLive ? "#6366f1" : "#334155",
                    color: "white",
                    cursor: isLive ? "pointer" : "not-allowed",
                    width: "100%",
                  }}
                >
                  {isLive ? "Start Now" : "Coming Soon"}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;